import React from 'react';
import Head from 'react-helmet';
import formatMessage from 'format-message';
import AppHandler from '../components/app-handler';
import Imported from '../components/search/imported-handler';
import SearchOptions from '../components/search/search-options';
import { SearchActions, SessionActions, RouterActions } from '../actions';
import { getState, subscribe } from '../store';
import PageTitle from '../components/common/page-title';
import { getDefaultSearchSortingOptions } from '../components/search/sorting/default-search-sorting-options';
import { getSortingFromQuery } from './util/get-sorting-from-query';
import { isCursorLimitReachedError } from '../common/is-cursor-limit-reached-error';

/* eslint-disable react/prop-types */
const View = ({ queryParams }) => {
  const {
    q,
    types,
    scopeIds,
    gradeIds,
    subjectIds,
    contentCategoryTypes
  } = queryParams;
  const { sortBy, sortOrder } = getSortingFromQuery(queryParams);
  const state = getState();

  return (
    <AppHandler
      activeHeader="imported"
      session={state.session}
      updates={state.updates}
      isManager={state.groups.isManager}
      logout={SessionActions.logout}
    >
      <div className="responsive-results-width">
        <Head title={formatMessage('Imported')} />
        <PageTitle title={formatMessage('Imported')} id="search-controls-heading" />
        <main className="Main">
          <SearchOptions
            featureFlags={state.featureFlags}
            searchPrivateObjects
            onChange={SearchActions.update}
            query={q}
            types={types ? types.split(',') : []}
            contentCategoryTypes={contentCategoryTypes ? contentCategoryTypes.split(',') : []}
            scopeIds={scopeIds ? scopeIds.split(',') : []}
            gradeIds={gradeIds ? gradeIds.split(',') : []}
            subjectIds={subjectIds}
            sortBy={sortBy}
            sortOrder={sortOrder}
            sortingOptions={getDefaultSearchSortingOptions()}
            consortiums={state.consortiums}
            groups={state.groups}
            canShowApprovedContent={state.account.settings.allowApprovedContent}
            canShowPublic={
              state.account.settings.canShowPublic &&
              state.session.sid &&
              !state.session.publicOnly
            }
            queryArialLabel={formatMessage(
              'Search Commons for course resources by tag, name, institution, or outcome'
            )}
            account={state.session.account}
            showFilters={state.filter.showFilterTray}
            disableSorting={state.results && isCursorLimitReachedError(state.results.error)}
            router={state.router}
            session={state.session}
          />
          <Imported {...state} sortBy={sortBy} sortOrder={sortOrder} />
        </main>
      </div>
    </AppHandler>
  );
};

export default function ({ location, render, resolve, exiting }) {
  RouterActions.backTo(formatMessage('Imported'), window.location.href);

  const unsubscribe = subscribe(() => render(<View queryParams={location.query} />));
  exiting.then(unsubscribe);
  render(<View queryParams={location.query} />);
  resolve();
}
